import React from 'react';
import { useOptIn } from '../OptInContext';
type NeonColor = 'purple' | 'cyan' | 'pink';
interface NeonButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  color?: NeonColor;
  variant?: 'solid' | 'outline';
  pulse?: boolean;
  /** When true, clicking opens the opt-in form first, then redirects to `href`. */
  gated?: boolean;
}
const colorMap: Record<NeonColor, {
  border: string;
  bg: string;
  text: string;
  shadow: string;
  hover: string;
}> = {
  purple: {
    border: 'border-purple-400',
    bg: 'bg-purple-500/20',
    text: 'text-purple-100',
    shadow: 'shadow-[0_0_14px_rgba(168,85,247,0.7)]',
    hover: 'hover:shadow-[0_0_28px_rgba(168,85,247,1)] hover:bg-purple-500/35'
  },
  cyan: {
    border: 'border-cyan-300',
    bg: 'bg-cyan-500/20',
    text: 'text-cyan-50',
    shadow: 'shadow-[0_0_14px_rgba(34,211,238,0.7)]',
    hover: 'hover:shadow-[0_0_28px_rgba(34,211,238,1)] hover:bg-cyan-500/35'
  },
  pink: {
    border: 'border-pink-400',
    bg: 'bg-pink-500/20',
    text: 'text-pink-50',
    shadow: 'shadow-[0_0_14px_rgba(236,72,153,0.7)]',
    hover: 'hover:shadow-[0_0_28px_rgba(236,72,153,1)] hover:bg-pink-500/35'
  }
};
export function NeonButton({
  children,
  color = 'purple',
  variant = 'solid',
  pulse = false,
  gated = false,
  className = '',
  onClick,
  ...props
}: NeonButtonProps) {
  const c = colorMap[color];
  const {
    openOptIn
  } = useOptIn();
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (gated && props.href) {
      e.preventDefault();
      openOptIn(props.href);
    }
    onClick?.(e);
  };
  return <a {...props} onClick={handleClick} className={['group inline-flex items-center justify-center gap-2 rounded-full border-2 font-display font-bold uppercase tracking-wider', 'px-7 py-3.5 text-sm sm:text-base transition-all duration-300 cursor-pointer', 'focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-white/40', c.border, variant === 'solid' ? c.bg : 'bg-transparent', c.text, c.shadow, c.hover, pulse ? 'glow-pulse' : '', className].join(' ')} data-id="element-138">
      {children}
    </a>;
}